// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"delete_wrapper__3pxGj","warningsWrapper":"delete_warningsWrapper__1dmFL"};